import React, { Suspense, useContext } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { CContainer, CSpinner } from '@coreui/react'
import routes from '../routes'
import { AuthorizationContext } from './auth/AuthProvider'

const AppContent = () => {
  const { userData } = useContext(AuthorizationContext)

  return (
    <CContainer fluid className="container-background">
      <Suspense
        fallback={
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <CSpinner color="primary" />
          </div>
        }
      >
        <Routes>
          {userData &&
            routes.map((route, idx) => (
              <Route
                key={route.name || route.path}
                path={route.path}
                exact={route.exact}
                element={
                  !process.env.REACT_APP_IGNORE_PERMISSIONS && route.permission && !userData?.permissions?.includes(route?.permission) ? (
                    <Navigate to="/restriction" />
                  ) : (
                    <route.element />
                  )
                }
              />
            ))}
        </Routes>
      </Suspense>
    </CContainer>
  )
}

export default React.memo(AppContent)
